module.exports = __webpack_public_path__ + "img/2024-12-12c_2.9ac43ad3.jpg";